export const MiniAppMenuItems = [
  {
    display: "Order history",
    path: "/shopping/view-order-history"
  }
];